 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account-integrations":"account-integrations","account-organization-address":"account-organization-address","account-organization-billing-settings":"account-organization-billing-settings","account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b":"account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b","account-organization-billing":"account-organization-billing","campaign-details~campaigns~letters-templates~templates":"campaign-details~campaigns~letters-templates~templates","campaigns~contacts":"campaigns~contacts","campaign-details~campaigns":"campaign-details~campaigns","campaigns":"campaigns","letters-templates~templates":"letters-templates~templates","letters-templates":"letters-templates","templates":"templates","contacts":"contacts","import-history":"import-history","letters-history":"letters-history","postcards-history":"postcards-history","account-organization-general":"account-organization-general","account-password":"account-password","account-preferences":"account-preferences","builder":"builder","campaign-details~contact-details~dashboard-mail":"campaign-details~contact-details~dashboard-mail","campaign-details~dashboard-mail":"campaign-details~dashboard-mail","campaign-details":"campaign-details","dashboard-mail":"dashboard-mail","contact-details":"contact-details","icons":"icons","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"account-integrations":"068d2f2f","account-organization-address":"f267e131","account-organization-billing-settings":"62ce496f","account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b":"514ab930","account-organization-billing":"58010d8f","campaign-details~campaigns~letters-templates~templates":"c27bc17b","campaigns~contacts":"2efa486a","campaign-details~campaigns":"9031ad33","campaigns":"a593cd88","letters-templates~templates":"2458c9ff","letters-templates":"0b880e73","templates":"124fa486","contacts":"465d1ff6","import-history":"10b09949","letters-history":"13c446e0","postcards-history":"2630c54a","account-organization-general":"5ad462f5","account-password":"dd5c93ac","account-preferences":"fead7ea3","builder":"173c6ed8","campaign-details~contact-details~dashboard-mail":"c6e3069f","campaign-details~dashboard-mail":"ea6e4dd3","campaign-details":"55cbfe42","dashboard-mail":"6af40982","contact-details":"87d8964b","chunk-148c8dd0":"6fea1d62","chunk-31a09ce6":"419acce2","chunk-3218a9d7":"4d251757","chunk-359cc37c":"8cbf5806","chunk-43076661":"fbf93a7b","chunk-6cd684ac":"e401f391","chunk-7d7e70c1":"054ab8f9","chunk-838c1dd6":"78347b9c","chunk-9abf216a":"0344ecdb","icons":"08b2d340","canvg":"097c28ea","pdfmake":"e4d75e26","xlsx":"88fc4eb2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account-integrations":1,"account-organization-address":1,"account-organization-billing-settings":1,"account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b":1,"account-organization-billing":1,"campaign-details~campaigns~letters-templates~templates":1,"campaigns~contacts":1,"campaign-details~campaigns":1,"campaigns":1,"letters-templates~templates":1,"letters-templates":1,"templates":1,"contacts":1,"import-history":1,"letters-history":1,"postcards-history":1,"account-organization-general":1,"account-password":1,"account-preferences":1,"builder":1,"campaign-details~dashboard-mail":1,"campaign-details":1,"dashboard-mail":1,"contact-details":1,"chunk-148c8dd0":1,"chunk-31a09ce6":1,"chunk-3218a9d7":1,"chunk-359cc37c":1,"chunk-43076661":1,"chunk-6cd684ac":1,"chunk-7d7e70c1":1,"chunk-838c1dd6":1,"chunk-9abf216a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account-integrations":"account-integrations","account-organization-address":"account-organization-address","account-organization-billing-settings":"account-organization-billing-settings","account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b":"account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b","account-organization-billing":"account-organization-billing","campaign-details~campaigns~letters-templates~templates":"campaign-details~campaigns~letters-templates~templates","campaigns~contacts":"campaigns~contacts","campaign-details~campaigns":"campaign-details~campaigns","campaigns":"campaigns","letters-templates~templates":"letters-templates~templates","letters-templates":"letters-templates","templates":"templates","contacts":"contacts","import-history":"import-history","letters-history":"letters-history","postcards-history":"postcards-history","account-organization-general":"account-organization-general","account-password":"account-password","account-preferences":"account-preferences","builder":"builder","campaign-details~contact-details~dashboard-mail":"campaign-details~contact-details~dashboard-mail","campaign-details~dashboard-mail":"campaign-details~dashboard-mail","campaign-details":"campaign-details","dashboard-mail":"dashboard-mail","contact-details":"contact-details","icons":"icons","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"account-integrations":"52e07d11","account-organization-address":"a8e56926","account-organization-billing-settings":"8d173c2a","account-organization-billing~campaigns~contacts~import-history~letters-history~letters-templates~pos~a5dd996b":"8533291a","account-organization-billing":"d02d4337","campaign-details~campaigns~letters-templates~templates":"eaf4760f","campaigns~contacts":"9456254e","campaign-details~campaigns":"3f2ccd79","campaigns":"e03dacde","letters-templates~templates":"15b7ec9f","letters-templates":"068777da","templates":"054298f7","contacts":"8698607b","import-history":"e0b3c88c","letters-history":"3a385890","postcards-history":"7913c6ed","account-organization-general":"fad0123f","account-password":"8f041ef3","account-preferences":"3c8bf50e","builder":"c84fc1b9","campaign-details~contact-details~dashboard-mail":"31d6cfe0","campaign-details~dashboard-mail":"cadd3660","campaign-details":"09071e4c","dashboard-mail":"81134c66","contact-details":"9af659ef","chunk-148c8dd0":"260ca2cd","chunk-31a09ce6":"88d46c2f","chunk-3218a9d7":"2f0945b0","chunk-359cc37c":"482fe589","chunk-43076661":"5876dea1","chunk-6cd684ac":"708e0860","chunk-7d7e70c1":"08713e79","chunk-838c1dd6":"fbe0a018","chunk-9abf216a":"747197a8","icons":"31d6cfe0","canvg":"31d6cfe0","pdfmake":"31d6cfe0","xlsx":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
